import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getCategories } from "../../products/api";
import CategoryThumb from "../../products/components/CategoryThumb";
import HomeSection from "./HomeSection";

const CategoryTile = ({ category }) => (
  <Link to={`/products?category=${category.id}`} className="category-tile">
    <CategoryThumb image={category.image} className="category-tile__thumb" />
    <span className="category-tile__name">{category.name}</span>
  </Link>
);

/** Category tiles linking to each category's products. */
const HomeCategories = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    getCategories()
      .then((data) => setCategories(Array.isArray(data) ? data : data?.content || []))
      .catch((error) => console.error("Error fetching categories:", error));
  }, []);

  if (categories.length === 0) return null;

  return (
    <HomeSection title="Categories">
      <div className="category-tiles">
        {categories.map((category) => (
          <CategoryTile key={category.id} category={category} />
        ))}
      </div>
    </HomeSection>
  );
};

export default HomeCategories;
